<ng-template [ngIf]="hasMessage && !hasChatMessage">
<div (click)="hideMessage()" style="top: 5em; width: 100%; margin:auto; text-align: center; z-index: 999;"
     [ngClass]="{ 'alert': message, 'alert-success': message?.type === 'success', 'alert-danger': message?.type === 'error', 'alert-warning': message?.type === 'warning' }">{{message?.text}}</div>
</ng-template>


<ng-template [ngIf]="hasChatMessage">
<div class="chat-new-message">
  <a class="naked muted" (click)="hideMessage()"><i class="fa fa-times">&nbsp;</i></a>
    {{messageAsAlertMessage.message}}
  <a class="naked muted" (click)="viewMessage()" >{{'View'|translate}}&nbsp;<i class="fa fa-chevron-right"></i></a>
</div>
</ng-template>

<!--
<div class="chat-new-message" >
  <a class="naked muted" (click)="hideMessage()"><i class="fa fa-times">&nbsp;</i></a>
  Jerome wrote 'blablalbalbla'
  <a class="naked muted" (click)="viewMessage()" >{{'View'|translate}}&nbsp;<i class="fa fa-chevron-right"></i></a>
</div>
-->
